"use client";
import Hero from "../components/hero/Hero";
import { redirect } from "next/navigation";
import UserDashboardPage from "./user/dashboard/page";

export default function Home() {
  return <UserDashboardPage />;
}
